import { createStore, applyMiddleware } from "redux";
import { routerMiddleware } from "react-router-redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import createHistory from "history/createBrowserHistory";
import reducers from "../reducers";
import LoginPersistMiddleware from "../middlewares/loginPersists";

export const history = createHistory();

const middleware = [];
middleware.push(logger);
middleware.push(routerMiddleware(history));
middleware.push(thunk);
middleware.push(LoginPersistMiddleware);

const store = createStore(reducers, applyMiddleware(...middleware));

if (process.env.NODE_ENV === "development") {
  window.store = store;
}

export default store;



// WEBPACK FOOTER //
// ./src/config/store.js